import http from "@/http/aisea/axios";
const resource = "/enterprises/crews/payroll";
import { paramsToQueryString } from "@/utils/ObjectUtil";

export default {
  export(
    exportId, // number | `${number}`
    payload, // {start_date: `${yyyy-mm-dd}`; end_date: `${yyyy-mm-dd}`; enterprise_manning_vessel_ids: undefined | `${number}`[];}
    responseType = "blob",
    paramsSerializer = paramsToQueryString
  ) {
    const path = `${resource}/export/${exportId}`;
    return http.get(path, {
      params: payload,
      responseType,
      paramsSerializer,
    });
  },
};
